import store from "../store";

export function isBulgarian(country) {
    return country?.toLowerCase() === "bg" || store.getState().authentication.data?.country?.toLowerCase() === "bg"
}